import React, { useState } from 'react';
import Button from 'Common/components/Button';
import { CloseSharp } from '@material-ui/icons';
import Draggable from 'react-draggable';
import styled from 'styled-components/macro';
import colors from 'Common/constants/colors';

const DraggableImageWrapper = styled.div`
    position: fixed;
    z-index: 9999;
    cursor: move;
    box-shadow: 0 2px 6px rgb(0, 0, 0, 0.4), 0 0 0 1px rgb(0, 0, 0, 0.17);
    border-radius: 4px;
    overflow: hidden;

    img {
        display: block;
        width: 100%;
        max-width: 550px;
        min-width: 350px;
        pointer-events: none;
    }

    button {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 40px;
        background: ${colors.ALT_GRAY};
        border: 0;
        border-radius: 0 0 0 4px;

        svg {
            margin-right: 0;
        }
    }
`;

const PreviewImage = styled.div`
    width: 60px;
    height: 28px;
    border: 2px solid #2f2c2b;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    border-radius: 4px;
`;

const OpenPreviewButton = styled.button`
    position: absolute;
    display: flex;
    align-items: center;
    top: 50%;
    right: 0;
    overflow: hidden;
    width: auto;
    height: 32px;
    padding: 0;
    background: ${colors.ALT_DARKEST_GRAY};
    border: 2px solid ${colors.ALT_DARKEST_GRAY};
    outline: 0 none;
    color: ${colors.LIGHTEST_GRAY};
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    cursor: pointer;
    transform: translateY(-50%);
    border-radius: 4px;

    &:hover,
    &:focus {
        background: ${colors.ORANGE};
        border-color: ${colors.ORANGE};
        color: ${colors.DARKEST_GRAY};
    }

    > span {
        display: none;
    }

    @media screen and (min-width: 375px) {
        padding-left: 10px;

        > span {
            display: block;
            margin-right: 10px;
        }
    }
`;

const LicensePreview = ({ path }) => {
    const [isImageOpened, setIsImageOpened] = useState(false);

    const handleImageOpen = () => {
        setIsImageOpened(true);
    };

    const handleImageClose = () => {
        setIsImageOpened(false);
    };

    return (
        <>
            <OpenPreviewButton type="button" onClick={handleImageOpen}>
                <span>Vorschau</span>
                <PreviewImage
                    style={{
                        backgroundImage: `url(${path})`,
                    }}
                />
            </OpenPreviewButton>
            {isImageOpened && (
                <Draggable cancel=".draggable-cancel">
                    <DraggableImageWrapper>
                        <Button
                            className="draggable-cancel"
                            onClick={handleImageClose}
                        >
                            <CloseSharp />
                        </Button>
                        <img src={path} alt="" />
                    </DraggableImageWrapper>
                </Draggable>
            )}
        </>
    );
};

LicensePreview.defaultProps = {};

LicensePreview.propTypes = {};

export default LicensePreview;
